import {useState} from 'react';

const useHighlightsSwiper = ({sliderRef, visibleCount, handleCarouselLeave, handleCarouselEnter, initialSlide = 0}) => {
    const [currentSlide, setCurrentSlide] = useState(initialSlide);

    const options = {
        slidesPerView: visibleCount,
        spaceBetween: 0,
        speed: 400,
        centeredSlides: true,
        loop: true,
        allowTouchMove: false,
        initialSlide,
        onRealIndexChange: ({realIndex}) => setCurrentSlide(realIndex),
        onSlideChangeTransitionStart: ({previousRealIndex}) => handleCarouselLeave(previousRealIndex),
        onSlideChangeTransitionEnd: ({realIndex}) => handleCarouselEnter(realIndex),
    };

    const handlePreviousClick = () => {
        sliderRef.current?.swiper.slidePrev();
    };

    const handleNextClick = () => {
        sliderRef.current?.swiper.slideNext();
    };

    const handleOverlayClick = (i) => {
        const swiper = sliderRef.current?.swiper;
        const isNextSlide = i === (currentSlide + 1) % swiper?.slides.length;

        if (isNextSlide) {
            swiper?.slideNext();
        } else {
            swiper?.slidePrev();
        }
    };

    return {options, currentSlide, handlePreviousClick, handleNextClick, handleOverlayClick};
};

export default useHighlightsSwiper;
